<template>
  <div style="padding:10px 20px;">
    <div style="text-align:left;">
      <div style="margin-bottom: 12px;font-size:20px;font-weight:600">
        <span>
          入库单号: {{ $route.query.inboundCode }}
        </span>
        <template v-if="inboundType == 0">
          <span>
            采购单号: {{ $route.query.purchaseNoList.split(',').join('、') }}
          </span>
          <span>
            采购员: {{ $route.query.purchaseUserName }}
          </span>
          <span>
            物流单号: {{ $route.query.expressNoList.split(',').join('、') }}
          </span>
        </template>
        <template v-else>
          <span>
            创建人: {{ $route.query.creatorName }}
          </span>
        </template>
      </div>
      <el-form :inline="true" :model="form" label-position="left" @keydown.native.enter="onSubmit"
        class="demo-form-inline">
        <el-form-item label="平台SKU">
          <el-input maxlength='50' v-model="form.productSku" @keydown.native.enter="search"></el-input>
        </el-form-item>
        <el-form-item label="批次号">
          <el-input maxlength='50' v-model="form.pkgCode" @keydown.native.enter="search"></el-input>
        </el-form-item>
        <el-form-item label="操作节点">
          <el-select v-model="form.node">
            <el-option :label="item.label" :value="item.value" v-for="item in $route.query.inboundType == 0?nodes_purchase:nodes" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单编号" v-if="$route.query.inboundType == 0">
          <el-input maxlength='50' v-model="form.platformOrderNo" @keydown.native.enter="search"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <WmsTable :columns="realCol" :dataSource="dataSource" :hasHeader="false" :isPagination="query"
        @pageChange="pageChangeCall">
        <div slot="content" slot-scope="{text,record,index}">
          <ellipsisDiv :text="text"></ellipsisDiv>
        </div>
      </WmsTable>
    </div>
  </div>
</template>
<script>
import WmsTable from "@/components/WmsTable";
import ellipsisDiv from "@/components/WmsTable/ellipsisDiv";
import { operateRecord } from "@/apis/inHouse";
export default {
  name: 'inboundDetail',
  components: {
    WmsTable,
    ellipsisDiv
  },
  data() {
    return {
      creatorName: '',
      form: {
        productSku: '',
        pkgCode: '',
        node: ''
      },
      inboundType:0,
      query: {
        current: 1,
        pageSize: 20,
        total: 0
      },
      nodes: Object.entries({
        '': "全部",
        CREATE_MANUAL_INBOUND_ORDER: "创建手动入库单",
        ONE_KEY_CONFIRM:'一键入库',
        CANCEL_SKU_INBOUND:'取消入库',
        ONE_KEY_COMPLETE:'完成入库',
        CLOSE_INBOUND_ORDER:'关闭入库单'

      }).map(([k, v]) => {
        return { label: v, value: k }
      }),
      nodes_purchase:Object.entries({
        '': "全部",
        LOGISTICS_SIGN: "签收",
        NORMAL_INBOUND: "入库",
        ABNORMAL_CUSTOMER_INBOUND: "异常上报客户",
        ABNORMAL_PURCHASE_INBOUND: "异常上报采购",
        BAD_INBOUND: "次品",
        TRANSFER_CONFIRM: "移库",
        CHECKING: "详细质检",
        PRINT_LABEL: "打印水洗标",
        SHELVE: "上架",
        COMBINED_PICKING: "组合拣货",
        COMBINED_TRANSFER: "调拨拣货",
        PKG_SPLIT: "拆包新增异常",
        UPDATE_LOGISTICS_NUMBER: "更新运单号",
        UPDATE_SPECIAL_CHECK_REQUIREMENT: "修改特殊质检要求",
        REMOVE_LOGISTICS_NUMBER: '删除运单号',

      }).map(([k, v]) => {
        return { label: v, value: k }
      }),
      columns: [
        {
          title: "操作节点",
          dataIndex: "nodeName",
          key: "nodeName",
        },
        {
          title: "平台SKU",
          dataIndex: "productSku",
          key: "productSku",
        },
        {
          title: "批次号",
          dataIndex: "pkgCode",
          key: "pkgCode",
        },
        {
          title: "内容",
          dataIndex: "content",
          key: "content",
          width: 400,
          scopedSlots: {
            customRender: "content",
          },
        },
        {
          title: "实际导入数量",
          dataIndex: "num",
          key: "num",
          customRender: (text) => {
            return text ?? '-'
          },
          width: 100,
        },
        {
          title: "操作人",
          dataIndex: "creatorName",
          key: "creatorName",
        },
        {
          title: "操作时间",
          dataIndex: "createTime",
          key: "createTime",
        },
      ],
      dataSource: [],
      realCol:[]
    }
  },
  methods: {
    search() {
      const params = {
        inboundCode: this.$route.query.inboundCode,
        ...this.form,
        pageNum: this.query.current,
        pageSize: this.query.pageSize
      }
      this.dataSource = []
      operateRecord(params).then(res => {
        if (res.data) {
          this.query.total = res.data.total
          this.dataSource = res.data.records
        }
      })
    },
    reset() {
      this.form = {
        productSku: '',
        pkgCode: '',
        node: ''
      }
      this.search()
    },
    pageChangeCall(payload) {
      this.query.current = payload.current
      this.query.pageSize = payload.pageSize
      this.search()
    }
  },
  watch: {
    '$route.query': {
      handler: function (newVal) {
        if (newVal && newVal.inboundCode) {
          console.log(newVal)
          Object.keys(this.form).forEach(i => { this.form[i] = "" })
          this.inboundType = this.$route.query.inboundType
          this.realCol = [...this.columns]
          if (this.$route.query.inboundType == 0) {
            this.realCol.splice(4, 0, {
              title: "订单编号",
              dataIndex: "platformOrderNo",
              key: "platformOrderNo",
            })
            let index = this.realCol.findIndex(item=>item.dataIndex == 'num')
            this.realCol[index].title = '商品数量'
          }
          this.creatorName = this.$route.query.purchaseUserName
          this.search()
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
  },
  activated() {
  }
}
</script>